module.exports = __webpack_public_path__ + "img/hr.cea381a3.svg";